import classNames from 'classnames';
import React, { forwardRef } from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';
import Spinner from '@commons/Spinner';

import styles from './button.scss';

export const BUTTON_STYLES = {
  PRIMARY: classNames(styles.button, styles.button_isPrimary),
  SECONDARY: classNames(styles.button, styles.button_isSecondary),
  TERTIARY: classNames(styles.button, styles.button_isTertiary)
};

interface ButtonProps {
  caption?: string;
  containerStyles?: string;
  domId?: string;
  formKey?: string;
  hasSpinner?: boolean;
  name?: string;
  showArrowIcon?: boolean;
  styling?: string;
  onClick?: (...args: unknown[]) => void;
}

const Button = forwardRef<HTMLElement, ButtonProps>((props, ref) => {
  const {
    caption,
    containerStyles,
    domId,
    formKey,
    hasSpinner,
    name,
    onClick,
    showArrowIcon,
    styling,
    type
  } = props;
  const buttonClassNames = `${name} ${styling}`;
  const disabled = { disabled: hasSpinner };
  const getIcon = () => {
    if (hasSpinner) {
      return <Spinner />;
    }
    if (showArrowIcon) {
      return <Icon containerStyles={styles.buttonArrowIcon} type={ICON_TYPES.ARROW_RIGHT} />;
    }
  };
  return (
    <div className={containerStyles}>
      <button
        type={type}
        className={buttonClassNames}
        id={domId}
        value={caption}
        name={formKey}
        {...disabled}
        ref={ref}
        onClick={onClick}>
        <span className={styles.buttonCaption}>{caption}</span>
        {getIcon()}
      </button>
    </div>
  );
});
Button.defaultProps = {
  type: 'submit',
  hasSpinner: false
};
export default Button;
